import React from 'react'
import HeroImage from "../assets/project.jpg"
import HeroComp from '../components/HeroComp'
import ProjectComp from '../components/ProjectComp'

export default function Project() {
  return (
    <>
      <HeroComp heading="My Projects" paragraph="You can check my project.. Here is some of my Latest Projects" src={HeroImage}/>
      <ProjectComp />
    </>
  )
}
